/** Open WhatsApp for a caregiver — freemium limits enforced by the API when authenticated. */
export function initiateWhatsappCall({ caregiverId, phone, whatsappUrl }) {
  const id = String(caregiverId || "");
  if (!id) return { ok: false, error: "Caregiver not found." };
  const url = whatsappUrl || buildWhatsappCallUrl(phone);
  if (!url) return { ok: false, error: "Caregiver phone is not available yet." };
  window.open(url, "_blank", "noopener,noreferrer");
  return { ok: true, url };
}

export function buildWhatsappCallUrl(phoneE164) {
  const digits = String(phoneE164 || "").replace(/\D/g, "");
  if (!digits) return null;
  const normalized = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${normalized}`;
}

export const SUPPORT_WHATSAPP_URL =
  process.env.REACT_APP_SUPPORT_WHATSAPP_URL || "https://wa.me/919876543210";
